<template>
    <div v-if="coffees.length > 0" class="onboarding-coffee-card-list padded">
        <div v-if="coffees.length < 5" class="onboarding-skip-top">
            <h2>Uh oh :( sadly there aren't many coffees that meet your criteria</h2>
            <div class="txt-msg-top">
                <h3>May we suggest you check off more coffee sizes</h3>
                <h3>Which will return several more results</h3>
            </div>
        </div>
        <div class="coffee-card-list">
            <div class="coffee-card-wrapper" v-for="(coffee, index) in coffees">
                <h1 class="top-match-heading">#{{ index + 1 }}</h1>
                <h3 class="matching-score" :style="{ 'color': getFontColor(index, index) }">{{ coffee.score }}% MATCH</h3>
                <coffee-card
                        class="coffee-card"
                        :coffee="coffee"
                        :seller="coffee.seller"
                        :style="{ 'background-color': getBackgroundColor(index, index) }"
                        :onboarding="true"
                        :default-grind="orderPreferences && orderPreferences.grind"
                        :default-size="orderPreferences.size"
                        :select5lb="orderPreferences.size === '5lb'"
                        :key="coffees.id"
                        v-on:buy-now="buyNow"
                />
            </div>
        </div>
        <div class="onboarding-skip" v-if="orderPreferences.subscribe && hasReferral">
            <h2>Show me all your coffees!</h2>
            <p>Save your preference to get your $5 discount
                off of your first 8 orders.<br>Then shop around and order whenever you want.</p>
            <h3 @click="openSignUpForm()" class="skip-btn">save quiz results</h3>
        </div>
        <div class="onboarding-skip" v-else-if="orderPreferences.subscribe">
            <h2>Show me all your coffees!</h2>
            <p>Save your preferences to get your $10 discount.<br>Then shop around and order whenever you want.</p>
            <h3 @click="openSignUpForm()" class="skip-btn">save quiz results</h3>
        </div>
        <div class="onboarding-skip" v-else>
            <h2>Show me all your coffees!</h2>
            <p>Save your preferences to get your $5 discount.<br>Then shop around and order whenever you want.</p>
            <h3 @click="openSignUpForm()" class="skip-btn">save quiz results</h3>
        </div>

        <buy-now-form-shell
                :order="buyNowOrder"
                :buy-now-discounts="buyNowProps.buyNowDiscounts"
                :custom-bag-discounts="buyNowProps.customBagDiscounts"
                :is-user-signed-in="buyNowProps.isUserSignedIn"
                :stripe-publishable-key="buyNowProps.stripePublishableKey"
                :username="buyNowProps.username"
                :email="buyNowProps.email"
                :shipping="buyNowProps.shipping"
                :credit-card-last-digits="buyNowProps.billing && buyNowProps.billing.creditCardLastDigits"
                :applicable-credit-amount-cents="buyNowProps.applicableCreditAmountCents"
                :current-url="buyNowProps.currentUrl"
                :tax-rate="buyNowProps.taxRate"
                :key="componentKeyPrefix + buyNowComponentKey"
                :onboarding="true"
                :custom-sizes="customSizes"
                :onboarding-order-preferences="orderPreferences"
                :sign-up="signUpOnly"
                v-on:closed="onBuyNowFormClosed"
                v-on:account-created="onAccountCreated"
                v-on:order-completed="onOrderCompleted"
                ref="buyNowForm"
        />

    </div>
    <div v-else class="onboarding-coffee-card-list padded">
        <div class="onboarding-skip">
            <h1>Uh oh :( sadly there aren't any Matching Coffees</h1> 
            <div class="txt-msg">
                <h3>May we suggest you check off more coffee sizes</h3>
                <h3>Which will return several more results.</h3>
            </div>
        </div>
    </div>
</template>

<script>
    import CoffeeCard from "../coffee-card-home";
    import BuyNowFormShell from "../buy-now/buy-now-form-shell";
    import CoffeeMixin from "../../../mixins/coffee-mixin";
    import BuyNowMixin from "../../../mixins/buy-now-mixin";
    import GaMixin from '../../../mixins/google-analytics-mixin';

    export default {
        components: {
            CoffeeCard,
            BuyNowFormShell,
        },
        mixins: [
            CoffeeMixin,
            BuyNowMixin,
            GaMixin
        ],
        props: {
            coffees: Array,
            maxCardsPerRow: {
                type: Number,
                default: 9
            },
            backgroundColorOffset: {
                type: Number,
                default: 0
            },
            buyNowProps: Object,
            onboardingQuizAnswers: Object,
            orderPreferences: Object,
            customSizes: Array,
            minValue: Number,
            maxValue: Number
        },
        data: function () {
            return {
                buyNowOrder: undefined,
                buyNowComponentKey: 0,
                componentKeyPrefix: this.getRandomString(),
                signUpOnly: false,
                hasReferral: false
            }
        },
        mounted() {
            this.hasReferral = this.getReferralCodeCookie();
        },
        methods: {
            getBackgroundColorOffset(row) {
                const factor = 5;
                return (this.backgroundColorOffset * factor) + (row * factor);
            },
            getReferralCodeCookie() {
              const value = `; ${document.cookie}`;
              const parts = value.split(`; referral_code=`);
              if (parts.length === 2) return true;
              return false;
            },
            buyNow(order) {
                fbq('track', 'Onboarding: Coffee Selected');
                this.$refs.buyNowForm.setOrder(order);
                this.$refs.buyNowForm.open();
            },
            onBuyNowFormClosed() {
                // Vue component will reset data once the key changed.
                this.buyNowComponentKey += 1;
            },
            // HACK: This is a very hacky way to assign unique keys.
            getRandomString() {
                let str = '';

                const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                for( let i = 0; i < 10; i++ ) {
                    str += chars.charAt(Math.floor(Math.random() * chars.length));
                }
                return str;
            },
            onAccountCreated(orderedCoffeeId, reloadPage = false) {
                this.updateCoffeeProfile();
                this.addMatchingCoffeesToPlaylist(orderedCoffeeId);
                this.sendSignupEvent(`Onboarding Sign-up - ${this.orderPreferences.subscribe ? 'Subscription' : 'Manual'}`);
                this.updatePlaylistFilter(reloadPage);
            },
            updateCoffeeProfile() {
                this.$api.post('v1/coffee_preferences', { picks: this.onboardingQuizAnswers })
                    .then(res => {})
                    .catch(err => console.error(err));

                // this.$api.patch('v1/onboarding/update_coffee_profile', { answers: this.onboardingQuizAnswers })
                //     .then(res => {})
                //     .catch(err => console.error(err));
            },
            updatePlaylistFilter(reloadPage) {

                let sizes = this.orderPreferences.size;
                sizes = sizes.sort(function(a, b){return parseFloat(a) - parseFloat(b)});
                const filters = {
                    grind: this.orderPreferences.grind,
                    type: this.orderPreferences.type,
                    size: sizes,
                    subscribe: this.orderPreferences.subscribe,
                    min: this.minValue,
                    max: this.maxValue,
                };
                this.$api.patch('v1/playlists/update_suggestion_filter', { filters, frequency: this.orderPreferences.frequency, skipNextBatch: true})
                    .then(res => { 
                        window.location.replace('/coffees');
                    })
                    .catch(err => console.error(err));
            },
            onOrderCompleted() {
                if (this.orderPreferences.subscribe) {
                    this.activatePlaylist();
                } else {
                    window.location.replace('/coffees');
                }
            },
            addMatchingCoffeesToPlaylist(orderedProductId) {
                // Exclude the product which was ordered from the matching coffees
                let orderSizes = this.orderPreferences.size;
                orderSizes = orderSizes.sort(function(a, b){return parseFloat(a) - parseFloat(b)});
                const product_ids = this.coffees.filter(c => c.id !== orderedProductId).map(c => c.id);
                const params = {
                    product_ids: product_ids,
                    size: orderSizes,
                    grind: this.orderPreferences.grind
                };

                this.$api.post('v1/playlists/add_items', params)
                    .then(() => {})
                    .catch(err => console.error(err));
            },
            activatePlaylist() {
                this.$api.patch('v1/playlists/activate', { frequency: this.orderPreferences.frequency, skipNextBatch: true } )
                    .then(() => window.location.replace('/coffees?open_playlist=true'))
                    .catch(() => {});
            },
            openSignUpForm() {
                this.signUpOnly = false;
                this.$refs.buyNowForm.open(true, true);
            }
        }, 
    }
</script>

<style lang="scss">
    @import "../../../styles/variables_home";

    .coffee-card-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }
    .coffee-card-wrapper {
        margin-bottom: 3rem;
        margin-left: 1rem;
        margin-right: 1rem;
    }
    .top-match-heading {
        font-size: 48px;
        color: $color-primary;
        margin-bottom: 0;
    }
    .matching-score {
        font-size: 20px;
        letter-spacing: 1px;
        margin: 0;
    }
    .onboarding-skip {
        margin-top: 5rem;
    }
    .onboarding-skip-top {
        margin-top: 0rem;
    }
    .skip-btn {
        color: $green-primary;
        cursor: pointer;
        &:hover {
            font-size: 26px;
        }
    }
    .txt-msg h3{
        color: #b09dbd;
    }
    .txt-msg-top h3{
        color: #b09dbd;
        margin: 0;
    }
    .txt-msg-top{
        margin-bottom: 3rem;
    }
    .price-range-slider {
        margin-bottom: 2rem;
        max-width: 400px !important;
        margin: 0 auto !important;
    }
    .vue-slider {
        margin-left: 1rem;
        margin-right: 1rem;
        max-width: 500px;
    }

    .vue-slider-process {
        background-color: #50784F;
    }

    .vue-slider-dot-tooltip-inner {
        color:#50784F;
        font-weight: bold !important;
        font-size: 20px;
        background-color: transparent;
        border-color: transparent;
    }

    .vue-slider-dot-handle {
        background-color: #50784F;
    }

    .vue-slider-rail {
        height: 14px;
    }
    .min-max-wrapper {
        display: flex;
        width: 100%;
        justify-content: space-between;
    }
    .min-max-wrapper  span {
        font-size: 20px;
        font-weight: 600;
    
    }
    
    .price-handler {
        max-width: 434px;
        margin: 0 auto;
    }

    .price-handler h4:last-of-type {
        position: relative;
        bottom: -17px;
        margin-bottom: 0;
        margin-top: 0;
    }
    
    
    .price-handler h4.setting-header {
        margin-bottom: 0;
    }
    
</style>
